export const SCHEDULE_DEMO_URL = 'https://calendar.app.google/6Sw6tt1QzX2DrFNk6';
